module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter5"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block9"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p164"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps-rw",
    staticStyle: {
      "font-size": "82%"
    }
  }, [_vm._v("T THE DINER")]), _vm._v(", they sat across from each other. Instead of coffee, Parker had iced tea, but Camaro had a hot cup with cream, along with a slice of key lime pie. The tartness and sweetness combined with the mild bitter flavor of the coffee played games on her tongue, and she enjoyed it. Parker added far too much sugar to his tea.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p165"
    }
  }, [_vm._v("“What do you do?” Camaro asked him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p166"
    }
  }, [_vm._v("“Me? Oh, I’m a business consultant. I go around to businesses and tell them how to improve their operation. Efficiency. Stuff like that.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p167"
    }
  }, [_vm._v("Camaro grinned a little. “That so?” she asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p168"
    }
  }, [_vm._v("“Yeah, sure.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p169"
    }
  }, [_vm._v("“Do business consultants work outdoors a lot?” Camaro asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p170"
    }
  }, [_vm._v("“What? You’re talking about the tan, right? I like to do yard work and gardening on the weekends with my daughter.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p171"
    }
  }, [_vm._v("She shook her head. “You are an absolutely awful liar,” she said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p172"
    }
  }, [_vm._v("“I’m not lying,” Parker said. “I’m a business consultant, and I’m going to take a few clients out fishing to butter them up a little before we make a deal. Try to jack my fee up, you know? That’s how you make a living.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p173"
    }
  }, [_vm._v("“I believe you’re chartering a boat,” Camaro said. “And I believe you have a daughter, but I think the rest of it is bullshit.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p174"
    }
  }, [_vm._v("Parker opened his mouth and then closed it again. Then he said, “I do have a daughter.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p175"
    }
  }, [_vm._v("“How old?” Camaro asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p176"
    }
  }, [_vm._v("“She’s fourteen. Going on forty. She’s trying to turn me gray, but I think I can keep a handle on her for a couple more years. When she hits sixteen, I don’t know what I’m going to do.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p177"
    }
  }, [_vm._v("“What about her mother?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p178"
    }
  }, [_vm._v("Parker made a gesture with his thumb, whisking the thought away. “She’s long gone. Out the door when Lauren was seven. The old, ‘I’m going to get some cigarettes,’ thing. Never called again, never wrote. She was just out of there. So it’s the two of us, me and Lauren.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p179"
    }
  }, [_vm._v("“Any other family?” Camaro asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p180"
    }
  }, [_vm._v("“I have a brother, but he’s not local. I think he’s seen Lauren once. No, twice. You?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p181"
    }
  }, [_vm._v("“A sister.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p182"
    }
  }, [_vm._v("“Huh,” Parker said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p183"
    }
  }, [_vm._v("“What do you really do?” Camaro asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p184"
    }
  }, [_vm._v("Parker rolled the moist glass of tea between his palms for a minute. The condensation made a smeary puddle on the tabletop. “Can we hold off on that question for a little bit? I’m kind of happy with the whole ‘business consultant’ thing right now.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p185"
    }
  }, [_vm._v("“Okay,” Camaro said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p186"
    }
  }, [_vm._v("“How about you? Maybe I can ask you some questions.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p187"
    }
  }, [_vm._v("Camaro shrugged. “Ask me anything you want.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p188"
    }
  }, [_vm._v("“You from around here?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p189"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p190"
    }
  }, [_vm._v("“Where’d you come from?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p191"
    }
  }, [_vm._v("“California originally.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p192"
    }
  }, [_vm._v("“How’d you end up in Florida?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p193"
    }
  }, [_vm._v("Camaro smiled to herself. She took a forkful of pie and held it between them a moment. “I rode my bike,” she said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p194"
    }
  }, [_vm._v("“Now who’s telling lies?” Parker asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p195"
    }
  }, [_vm._v("“No lies. Go ahead and ask me another.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p196"
    }
  }, [_vm._v("“If you’re from California, what are you doing running a fishing boat out of Miami? Why aren’t you off surfing somewhere or something?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p197"
    }
  }, [_vm._v("Camaro ate the piece of pie and followed it with coffee. She considered the question. “When I was growing up, my dad liked two things more than anything else in the world,” she said. “He liked fixing cars, and he liked fishing. Fast cars were his favorite. Muscle cars? Forget about it. He’d fall in love with anything that had a big engine. And when he wasn’t under a car getting oily, he was saving up his money to get on a fishing charter and go after barracuda, calico bass, yellowtail…whatever.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p198"
    }
  }, [_vm._v("“So you have fishing in your blood.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p199"
    }
  }, [_vm._v("“Something like that. I know how to put together an engine, and I can tell you where the fish are. That’s what my dad gave me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p200"
    }
  }, [_vm._v("“Can’t be a cheap business to get into. You said the boat cost a lot.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p201"
    }
  }, [_vm._v("“I had some money to spend.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p202"
    }
  }, [_vm._v("“You make a good living?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p203"
    }
  }, [_vm._v("“Good enough. Keeps me in my house, and I don’t starve. I make what I need and a little extra to put away. I keep up the boat myself and that saves a bundle. Whatever it takes to go on.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p204"
    }
  }, [_vm._v("“And you still don’t want more than you’re charging me,” Parker said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p205"
    }
  }, [_vm._v("“Nope. The price is one seventy-five a person and that’s it. More if you need gear. I told you: I like to keep things simple.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p206"
    }
  }, [_vm._v("“I can respect that,” Parker said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p207"
    }
  }, [_vm._v("“I’m glad. Some guys don’t.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p208"
    }
  }, [_vm._v("“I get the feeling those guys don’t last too long around you,” Parker said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p209"
    }
  }, [_vm._v("“They don’t,” Camaro told him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p210"
    }
  }, [_vm._v("Parker was quiet awhile, and Camaro thought he’d finished talking, but he spoke up again. “So you have a sister, huh?” he asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p211"
    }
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p212"
    }
  }, [_vm._v("“I’m surprised she doesn’t help you run the business.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p213"
    }
  }, [_vm._v("“She doesn’t live around here. Besides, I don’t think she liked fishing as much as our dad did. She was the one who always got seasick.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p214"
    }
  }, [_vm._v("“That’s funny,” Parker said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p215"
    }
  }, [_vm._v("Camaro finished off the last of her pie and drained the coffee cup. The waitress came by with the pot to top it off, but Camaro put her hand over it and asked for the check instead. “I have a night charter tonight,” she told Parker. “We’re headed out around eight.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p216"
    }
  }, [_vm._v("“What time is it now?” Parker asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p217"
    }
  }, [_vm._v("“About five. That gives us a couple of hours.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p218"
    }
  }, [_vm._v("“A couple of hours for what?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p219"
    }
  }, [_vm._v("The waitress put the check down between them. Camaro took it up and counted off the cost from the bills in her wallet, plus a twenty percent tip. She weighted it all down with her coffee cup. “I don’t want to go back to your place, and I don’t want you back at my place,” Camaro said. “But there’s the boat.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p220"
    }
  }, [_vm._v("“I’m still not following,” Parker said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p221"
    }
  }, [_vm._v("“Hey, listen: I know you’re a bad liar, but don’t tell me you’re slow on the uptake, too,” Camaro said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p222"
    }
  }, [_vm._v("She got up, and Parker followed her out.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31df441f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s008-Chapter-005.vue
// module id = 81
// module chunks = 0